module.exports = __webpack_public_path__ + "static/media/heavy_pound22.abcf8e11.jpg";